module.exports = __webpack_public_path__ + "img/ios.e514aacd.webp";